import './Answer.scoped.scss'
import { useDrag } from 'react-dnd'
import { useDrop } from 'react-dnd'
import PillEditor from 'Shared/components/PillEditor/PillEditor'
import NextAction from './NextAction'
import { useCallback } from 'react'
import useAct from '../hooks/useAct'
import GoalPicker from 'Shared/ScriptEditor/components/GoalPicker'

export default function Answer({ id, showAdvanced, readOnly, effortName, goals, mergeTags }) {
  const act = useAct()
  const answers = useSel(s => _.values(s.answers.entities).filter(a => a.active))
  const campaign = useSel(s => s.campaign)
  const showLengthWarning = campaign?.primaryType === 'WhatsApp' && campaign?.campaignType === 'sms_survey'
  const { answer, questionId, digitOrder, action, nextQuestionId, setsGoalId } = useSel(s => s.answers.entities[id])

  const [, drag] = useDrag({
    type: `${questionId}-answer`,
    item: { id }
  });

  const [, drop] = useDrop({
    accept: `${questionId}-answer`,
    drop(item, monitor) {
      act.scriptBuilder.answers.moveDigitOrder(item.id, digitOrder, { questionId })
    }
  });

  function setGoalId(goalId) {
    act.scriptBuilder.answers.upsert(id, { setsGoalId: goalId })
  }

  const ref = el => drag(drop(el))

  return (
    <div className='answer' ref={ref}>
      <div className='dragger'><div className='handle'></div></div>
      <div className="content-editor condensed">
        {readOnly ? (
          <input type="text" value={answer} disabled className='full-width' />
        ) : (
          <PillEditor
            condensed={true}
            initialValue={answer}
            onChange={useCallback((body) => act.scriptBuilder.answers.upsert(id, { answer: body }), [id])}
            availableTags={mergeTags}
          />
        )}
        {(showLengthWarning && answer && answer.length > 20) &&
          <span className='answer-length-warning'>WhatsApp answers are limited to 20 characters</span>
        }
      </div>
      {showAdvanced && (
        <div className='advanced-settings'>
          <NextAction
            answerId={id}
            questionId={questionId}
            action={action}
            answers={answers}
            nextQuestionId={nextQuestionId}
            onChange={(option) => act.scriptBuilder.answers.upsert(id, option.value)}
          />
          <GoalPicker
            goals={goals}
            effortName={effortName}
            setsGoalId={setsGoalId}
            onGoalChange={setGoalId}
          />
        </div>
      )}
      {!readOnly && (
        <button className='delete' onClick={() => act.scriptBuilder.answers.markInactive(id)}>
          <SvgIconsClose />
        </button>
      )}
    </div>
  )
}
